import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import './BarraBuscaComTodasUnidades.css';

import SpinnerLoading from '../SpinnerLoading';
import lupaIcon from '../../imagens/lupaIcon.png'
import { useClickOutside } from '../../hooks/clickOutside';
import { toastErrorPydantic } from '../../util/toast_pydantic';

import { useEffect, useRef, useState } from 'react';
import { servGetEstabelecimentos } from '../../servicos/estabelecimento';

function BarraBuscaComTodasUnidades({ setEstabelecimento, estabelecimentosVigentes, apenasQueEnviamRelatorio }) {

  const [opcaoSelecionada, setOpcaoSelecionada] = useState(null);
  // Assim que monta o componente já busca todas as unidades pra exibir caso o usuário queira
  const [allEstabelecimentos, setAllEstabelecimentos] = useState(null);
  const [resultadoBusca, setResultadoBusca] = useState([]);
  const [loading, setLoading] = useState(false);
  const [controladorValueInput, setControladorValueInput] = useState('');

  const monitoraCliqueFora = useRef(null);

  useEffect(() => {
    getEstabelecimentos()
  }, []);

  useClickOutside(monitoraCliqueFora, () => limparResultadoBusca());

  const handleChange = async (evento) => {
    const estabelecimentoNome = evento.target.value;
    setControladorValueInput(estabelecimentoNome)
    if (estabelecimentoNome.length >= 3) {
      try {
        setLoading(true);
        const estabelecimentosDaApi = await servGetEstabelecimentos(estabelecimentoNome, estabelecimentosVigentes, apenasQueEnviamRelatorio)
        setResultadoBusca(estabelecimentosDaApi)
      } catch (erro) {
        toastErrorPydantic(erro);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSelect = (estabelecimento) => {
    setEstabelecimento(estabelecimento);
    setOpcaoSelecionada(estabelecimento.nome);
    setResultadoBusca([])
  };

  async function getEstabelecimentos() {
    try {
      const estabelecimentosDaApi = await servGetEstabelecimentos(null, estabelecimentosVigentes, apenasQueEnviamRelatorio);
      setAllEstabelecimentos(estabelecimentosDaApi);
    } catch (erro) {
      toastErrorPydantic(erro);
    }
  }

  const limparResultadoBusca = () => {
    setResultadoBusca([])
  };

  const listarTudo = () => {
    if (!resultadoBusca) toast.error('Problema ao listar estabelecimentos/unidades')
    setResultadoBusca(allEstabelecimentos)
  };

  const resetInfo = () => {
    setEstabelecimento(null)
    setOpcaoSelecionada(null)
  };

  return (

    <div className='d-flex flex-column flex-md-row gap-2 align-items-center' ref={monitoraCliqueFora}>

      <div className='position-relative w-100'>
        <input
          className='form-control text-center'
          value={controladorValueInput}
          onChange={handleChange}
          onBlur={() => setControladorValueInput('')}
          placeholder={opcaoSelecionada || 'Unidade não selecionada'}
        />

        <div className='resultado-busca'>
          {loading ? (
            <div className='div-com-borda p-1'>
              <SpinnerLoading mensagemLoading='Carregando' />
            </div>
          ) : resultadoBusca && (
            <ul className='list-group-flush text-center m-0 p-0'>
              {resultadoBusca.map((estabelecimento) => (
                <li
                  className='list-group-item resultado-busca-item p-2'
                  key={estabelecimento.id}
                  onClick={() => handleSelect(estabelecimento)}
                >
                  {estabelecimento.nome}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <button className='text-nowrap btn btn-primary' type='button' onClick={listarTudo}>
        LIST TUDO
      </button>

      <button className='text-nowrap btn btn-primary' type='button' onClick={resetInfo}>
        LIMPAR
      </button>

    </div>

  );
};

export default BarraBuscaComTodasUnidades;

BarraBuscaComTodasUnidades.propTypes = {
  setEstabelecimento: PropTypes.func.isRequired,
  estabelecimentosVigentes: PropTypes.bool.isRequired,
  apenasQueEnviamRelatorio: PropTypes.bool.isRequired
};